import DragAndDropPaletteList from "./DragAndDropPaletteList";
import AnimateHeight from "react-animate-height";
import { useDataStoreMiro } from "../../../refractCommon/utils/useDataStoreMiro";
import { useDataStoreFirestore } from "../../../refractCommon/utils/useDataStoreFirestore";
import "./Colors_Tool.css";
import { extraPalettes } from "./ExtraPalettes";
import { useEffect, useState } from "react";
import { generateUID } from "../../Utils/generateUID";
import ToolTip from "../../../refractCommon/components/ToolTip";

let popularColors = require("nice-color-palettes");
const miro = window.miro;

function Palettes({ boardSelection, userIsPro, environment }) {
  const dataKey = "palettesTool";
  const dataPath = "_palettes";
  const [settingsBoardMine, dispatchSettingsBoardMine] = useDataStoreMiro(
    { [dataPath]: { _order: [] } },
    dataKey,
    true
  );
  const [settingsBoardShared, dispatchSettingsBoardShared] = useDataStoreMiro(
    { [dataPath]: { _order: [] } },
    dataKey,
    false
  );
  const [settingsCloudMine, dispatchSettingsCloudMine] = useDataStoreFirestore(
    { [dataPath]: { _order: [] } },
    dataKey,
    "mine"
  );
  const [settingsCloudShared, dispatchSettingsCloudShared] = useDataStoreFirestore(
    { [dataPath]: { _order: [] } },
    dataKey,
    "shared"
  );
  const [listsOpen, setListsOpen] = useState({
    boardMine: false,
    boardShared: false,
    cloudMine: false,
    cloudShared: false,
    useful: false,
    popular: false,
  });
  const [popularColorPalettes, setPopularColorPalettes] = useState([]);
  const [proShineMyCloud, setProShineMyCloud] = useState(false);
  const [proShineSharedCloud, setProShineSharedCloud] = useState(false);

  useEffect(() => {  // Popular Palettes
    let newPopularColorPalettes = [];
    let popularPaletteCount = 10;

    for (let index = 0; index < popularPaletteCount; index++) {
      let hexColorArray = popularColors[index];
      let newPaletteObject = {
        id: generateUID(),
        name: `${index}`,
        _colors: [],
      };
      hexColorArray.forEach((hexColor) => {
        let newColor = { color: hexColor, id: generateUID() };
        newPaletteObject._colors.push(newColor);
      });
      newPopularColorPalettes.push(newPaletteObject);
    }

    setPopularColorPalettes(newPopularColorPalettes);
  }, []);

  return (
    <div className="cs1 ce12 grid">
      <div id="saved-palettes" className="grid cs1 ce12">
        {/*  */}
        {/* BOARD MINE  */}

        <h3 className="h3 cs1 ce12 mt-0  mb-0">
          <b>My Palettes</b>
        </h3>
        <div
          className="cs1 ce12 grid  cursor-pointer"
          onClick={() => {
            let listsOpenNew = { ...listsOpen };
            listsOpenNew.boardMine = !listsOpenNew.boardMine;
            setListsOpen(listsOpenNew);
          }}>
          <div
            style={{
              cursor: "pointer",
            }}
            className={
              "cs1 icon m2  mt-0  " +
              " " +
              (listsOpen.boardMine === false
                ? " icon-arrow-right"
                : " icon-arrow-down")
            }></div>
          <div className="cs2 ce5 p-large mt-0 ">On this Board</div>
          <div className="cs12 ce12 p-large mt-0 softer-help">
            ({settingsBoardMine[dataPath].length})
          </div>
        </div>
        <AnimateHeight
          id="popular-palettes-panel"
          duration={1000}
          height={listsOpen.boardMine ? "auto" : 0}
          className="cs1 ce12"
          easing="cubic-bezier(0, 1, 0.5, 1)">
          <DragAndDropPaletteList
            items={settingsBoardMine[dataPath] || []}
            dataPath={dataPath}
            dispatch={dispatchSettingsBoardMine}
            boardSelection={boardSelection}
            userIsPro={userIsPro}
            environment={environment}
          />
        </AnimateHeight>

        {/* MY CLOUD (CLOUDMINE) */}
        {!userIsPro &&
          <ToolTip
            className="mt--16"
            placement={"top"}
            toolTipContent={
              <>
                Palettes you can access from all of your boards.<br></br>(PRO: coming
                soon)
              </>
            }>
            <div
              className="div cs1 ce12 mb-8"
              onMouseEnter={() => {
                if (!userIsPro) {
                  setProShineMyCloud(true);
                }
              }}
              onMouseLeave={() => {
                if (!userIsPro) {
                  setProShineMyCloud(false);
                }
              }}>
              <div className="cs1 ce12 grid cursor-default mt--8">
                <div className={"cs1 icon m2 mt-0"}>
                  <svg
                    width="7"
                    height="10"
                    viewBox="0 0 7 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6.41421 5L1.70711 9.70711C1.31658 10.0976 0.683417 10.0976 0.292893 9.70711C-0.0976311 9.31658 -0.0976311 8.68342 0.292893 8.29289L3.58579 5L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                      fill="var(--indigo400)"
                    />
                  </svg>
                </div>

                <div
                  className="cs2 ce5 p-large mt-0 "
                  style={{ color: "var(--indigo400)" }}>
                  All Boards
                </div>
                <p
                  onClick={async () => {
                    const stripeUrl =
                      "https://www.visualthinking.tools/powerpack-feedback/#comp-l3alhyjs";
                    window.open(stripeUrl, "_blank");
                  }}
                  className={
                    "ce12 p-small mb-0 mt-0 inline-pro-plan-upgrade-tag" +
                    " " +
                    (proShineMyCloud ? "pro-shine" : "")
                  }>
                  Pro
                </p>
              </div>
            </div>
          </ToolTip>
        }
        {userIsPro && <>
          <div
            className="cs1 ce12 grid  cursor-pointer"
            onClick={() => {
              let listsOpenNew = { ...listsOpen };
              listsOpenNew.cloudMine = !listsOpenNew.cloudMine;
              setListsOpen(listsOpenNew);
            }}>
            <div
              style={{
                cursor: "pointer",
              }}
              className={
                "cs1 icon m2  mt-0  " +
                " " +
                (listsOpen.cloudMine === false
                  ? " icon-arrow-right"
                  : " icon-arrow-down")
              }></div>
            <div className="cs2 ce5 p-large mt-0 ">All Boards</div>
            <div className="cs12 ce12 p-large mt-0 softer-help">
              ({settingsCloudMine[dataPath].length})
            </div>
          </div>
          <AnimateHeight
            id="popular-palettes-panel"
            duration={1000}
            height={listsOpen.cloudMine ? "auto" : 0}
            className="cs1 ce12"
            easing="cubic-bezier(0, 1, 0.5, 1)">
            <DragAndDropPaletteList
              items={settingsCloudMine[dataPath] || []}
              dataPath={dataPath}
              dispatch={dispatchSettingsCloudMine}
              boardSelection={boardSelection}
              userIsPro={userIsPro}
              environment={environment}
            />
          </AnimateHeight>
        </>
        }
        {/* BOARD SHARED  */}

        <hr className=" cs1 ce12 mb-8 "></hr>
        <h3 className="h3 cs1 ce12 mt-0 mb-0">
          <b> Shared Palettes</b>
        </h3>

        <div
          className="cs1 ce12 grid  cursor-pointer"
          onClick={() => {
            let listsOpenNew = { ...listsOpen };
            listsOpenNew.boardShared = !listsOpenNew.boardShared;
            setListsOpen(listsOpenNew);
          }}>
          <div
            style={{
              cursor: "pointer",
            }}
            className={
              "cs1 icon m2 mt-0" +
              " " +
              (listsOpen.boardShared === false
                ? " icon-arrow-right"
                : " icon-arrow-down")
            }></div>
          <div className="cs2 ce5 p-large mt-0 ">On this Board</div>
          <div className="cs12 ce12 p-large mt-0 softer-help">
            ({settingsBoardShared[dataPath].length})
          </div>
        </div>
        <AnimateHeight
          id="popular-palettes-panel"
          duration={1000}
          height={listsOpen.boardShared ? "auto" : 0}
          className="cs1 ce12"
          easing="cubic-bezier(0, 1, 0.5, 1)">
          <DragAndDropPaletteList
            items={settingsBoardShared[dataPath] || []}
            dataPath={dataPath}
            dispatch={dispatchSettingsBoardShared}
            boardSelection={boardSelection}
            userIsPro={userIsPro}
            environment={environment}
          />
        </AnimateHeight>

        {/* SHARED CLOUD SHARED */}
        {!userIsPro &&
          <ToolTip
            className="mt--16"
            placement={"top"}
            toolTipContent={
              <>
                Palettes your team can access from all team boards.<br></br>(PRO:
                coming soon)
              </>
            }>
            <div
              className="div cs1 ce12 mb-8"
              onMouseEnter={() => {
                if (!userIsPro) {
                  setProShineSharedCloud(true);
                }
              }}
              onMouseLeave={() => {
                if (!userIsPro) {
                  setProShineSharedCloud(false);
                }
              }}>
              <div className="cs1 ce12 grid cursor-default mt--8">
                <div className={"cs1 icon m2 mt-0"}>
                  <svg
                    width="7"
                    height="10"
                    viewBox="0 0 7 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6.41421 5L1.70711 9.70711C1.31658 10.0976 0.683417 10.0976 0.292893 9.70711C-0.0976311 9.31658 -0.0976311 8.68342 0.292893 8.29289L3.58579 5L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                      fill="var(--indigo400)"
                    />
                  </svg>
                </div>

                <div
                  className="cs2 ce5 p-large mt-0 "
                  style={{ color: "var(--indigo400)" }}>
                  This Team
                </div>
                <p
                  onClick={async () => {
                    const stripeUrl =
                      "https://www.visualthinking.tools/powerpack-feedback/#comp-l3alhyjs";
                    window.open(stripeUrl, "_blank");
                  }}
                  className={
                    "ce12 p-small mb-0 mt-0 inline-pro-plan-upgrade-tag" +
                    " " +
                    (proShineSharedCloud ? "pro-shine" : "")
                  }>
                  Pro
                </p>
              </div>
            </div>
          </ToolTip>
        }
        {userIsPro && <>
          <div
            className="cs1 ce12 grid  cursor-pointer"
            onClick={() => {
              let listsOpenNew = { ...listsOpen };
              listsOpenNew.cloudShared = !listsOpenNew.cloudShared;
              setListsOpen(listsOpenNew);
            }}>
            <div
              style={{
                cursor: "pointer",
              }}
              className={
                "cs1 icon m2  mt-0  " +
                " " +
                (listsOpen.cloudShared === false
                  ? " icon-arrow-right"
                  : " icon-arrow-down")
              }></div>
            <div className="cs2 ce5 p-large mt-0 ">This Team</div>
            <div className="cs12 ce12 p-large mt-0 softer-help">
              ({settingsCloudShared[dataPath].length})
            </div>
          </div>
          <AnimateHeight
            id="cloudShared-panel"
            duration={1000}
            height={listsOpen.cloudShared ? "auto" : 0}
            className="cs1 ce12"
            easing="cubic-bezier(0, 1, 0.5, 1)">
            <DragAndDropPaletteList
              items={settingsCloudShared[dataPath] || []}
              dataPath={dataPath}
              dispatch={dispatchSettingsCloudShared}
              boardSelection={boardSelection}
              userIsPro={userIsPro}
              environment={environment}
            />
          </AnimateHeight>
        </>
        }

        {/* USEFUL */}

        <hr className=" cs1 ce12 mb-8 "></hr>
        <h3 className="h3 cs1 ce11 mt-0 mb-0">
          <b>Useful Palettes</b>
        </h3>
        <div
          className="cs1 ce12 grid cursor-pointer"
          onClick={() => {
            let listsOpenNew = { ...listsOpen };
            listsOpenNew.useful = !listsOpenNew.useful;
            setListsOpen(listsOpenNew);
          }}>
          <div
            style={{
              cursor: "pointer",
            }}
            className={
              "cs1  icon m2 mb-0 mt-0  " +
              " " +
              (listsOpen.useful === false
                ? " icon-arrow-right"
                : " icon-arrow-down")
            }></div>
          <div className="cs2 ce6 p-large mt-0 ">For Any Miro User</div>
          <div className="cs12 ce12 p-large mt-0 softer-help">
            ({extraPalettes.useful.length})
          </div>
        </div>
        <AnimateHeight
          id="popular-palettes-panel"
          duration={1000}
          height={listsOpen.useful ? "auto" : 0}
          className="cs1 ce12"
          easing="cubic-bezier(0, 1, 0.5, 1)">
          <DragAndDropPaletteList
            items={extraPalettes.useful}
            boardSelection={boardSelection}
            userIsPro={userIsPro}
            environment={environment}
          />
        </AnimateHeight>

        {/* POPULAR */}

        <hr className=" cs1 ce12 mb-8 "></hr>
        <h3 className="h3 cs1 ce11 mt-0 mb-0">
          <b>Popular Palettes</b>
        </h3>
        <div
          className="cs1 ce12 grid cursor-pointer"
          onClick={() => {
            let listsOpenNew = { ...listsOpen };
            listsOpenNew.popular = !listsOpenNew.popular;
            setListsOpen(listsOpenNew);
          }}>
          <div
            style={{
              cursor: "pointer",
            }}
            className={
              "cs1  icon m2 mb-0 mt-0  " +
              " " +
              (listsOpen.popular === false
                ? " icon-arrow-right"
                : " icon-arrow-down")
            }></div>
          <div className="cs2 ce7 p-large mt-0 ">You May Enjoy</div>
          <div className="cs12 ce12 p-large mt-0 softer-help">
            ({popularColorPalettes.length})
          </div>
        </div>
        <AnimateHeight
          id="popular-palettes-panel"
          duration={1000}
          height={listsOpen.popular ? "auto" : 0}
          className="cs1 ce12"
          easing="cubic-bezier(0, 1, 0.5, 1)">
          <DragAndDropPaletteList
            items={popularColorPalettes}
            boardSelection={boardSelection}
            userIsPro={userIsPro}
            environment={environment}
          />
        </AnimateHeight>
      </div>
    </div>
  );
}

export default Palettes;
